import React, { Component } from "react"

import { genericBarPieScene } from "search-new/containers/Visualization/VisualizationScene/VisualizationScenes"

import {
    PressContactMajorRoleTypeFilter,
    PressContactOutletFilter,
} from "shared/search/containers/Filter/OfficialFilters"

import { inIssueFilter } from "shared/search/containers/Filter/FilterCreators"

export class PressContactOutletBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "pressContactOutletBarPieScene",
        filterId: PressContactOutletFilter.defaultProps.uniqueFilterId,
        variableRequestKey: "publicOrganizationFrequency",
        label: "Outlets",
        icon: "fa-book",
        sidebarTableLabel: "Press by Outlet",
    }

    render() {
        return genericBarPieScene(this.props)
    }
}

export const PressContactInIssuesBarPieScene = (props) => genericBarPieScene(props)
PressContactInIssuesBarPieScene.defaultProps = {
    uniqueVizSceneId: "pressContactInIssuesBarPieScene",
    filterId: inIssueFilter.defaultProps.uniqueFilterId,
    variableRequestKey: "inIssueFrequency",
    label: "Issues",
    icon: DjangIO.app.models.QuorumDataType.issue_management.icon,
    sidebarTableLabel: "Press tagged to Issue",
}

export class PressContactTypeBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "pressContactTypeBarPieScene",
        filterId: PressContactMajorRoleTypeFilter.defaultProps.uniqueFilterId,
        variableRequestKey: "pressContactFrequency",
        label: "Types",
        icon: DjangIO.app.models.QuorumDataType.press_contact.icon,
        sidebarTableLabel: "Press by Type",
        permissions: [DjangIO.app.models.PermissionType.media_relations],
    }

    render() {
        return genericBarPieScene(this.props)
    }
}
